// src/plugins/posthog.js
import posthog from 'posthog-js'

export default {
    install(Vue) {
        posthog.init('phc_otCem7GdBg7LtVY00PRg4C0uPbmgSE5s7Q51IMXDb5e', {
            api_host: 'https://posthog.hire3x.ai',
            defaults: '2025-05-24',
            debug: true,
            autocapture: false
        })

        Vue.prototype.$posthog = posthog
    }
}